import { Component, inject } from '@angular/core';
import { BaseFilterComponent } from '../base-filter/base-filter.component';
import { FormsModule } from '@angular/forms';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { NgIf } from '@angular/common';
import { SharedModule } from 'primeng/api';
import { TreeSelectModule } from 'primeng/treeselect';
import { TriStateCheckboxModule } from 'primeng/tristatecheckbox';
import { IndicatorStore } from '../../../stores/indicator/indicator.state';
import { Indicator } from '../../../models/indicator';
import { TagFilterDropdownComponent } from '../../atoms/tag-filter-dropdown/tag-filter-dropdown.component';
import { ProductFilterDropdownComponent } from '../../atoms/product-filter-dropdown/product-filter-dropdown.component';

@Component({
  selector: 'app-pool-filter',
  standalone: true,
  imports: [
    FormsModule,
    IconFieldModule,
    InputIconModule,
    InputTextModule,
    NgIf,
    SharedModule,
    TreeSelectModule,
    TriStateCheckboxModule,
    TagFilterDropdownComponent,
    ProductFilterDropdownComponent,
  ],
  templateUrl: './pool-filter.component.html',
  styleUrl: './pool-filter.component.scss',
})
export class PoolFilterComponent extends BaseFilterComponent<Indicator> {
  readonly store = inject(IndicatorStore);

  constructor() {
    super();
  }
}
